import { useForm } from 'react-hook-form';
import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';
import { Grid, Typography } from '@mui/material';
import MuiDialog from 'components/MuiDialog';
import CommonPatientInfo from '../components/CommonPatientInfo';
import { SurveyDialogProps, TMaturityDefaultValues } from '../type';
import Physical from './Physical';

const Maturity = (props: SurveyDialogProps<TMaturityDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    patientInfo,
    nurseName,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, getValues, setValue, register } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TMaturityDefaultValues) => {};

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Grid
        container
        wrap="wrap"
        rowSpacing={5}
        columnSpacing={3}
        sx={{ py: 5, px: 1 }}
      >
        <Typography
          sx={{
            margin: '40px auto 10px auto',
            fontWeight: '700',
            fontSize: '16px',
            textAlign: 'center',
          }}
        >
          고위험 신생아의 성숙도 사정 (New Ballard scale)
        </Typography>
        <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
        <Physical {...formProps} />
      </Grid>
    </MuiDialog.SurveyForm>
  );
};

export default Maturity;
